import { useState } from "react";
import { ProductMenu } from "../../__generated__/graphql";
import ResponsiveCDNImage from "../common/image/responsive-cdn-image";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

interface MenuImageSliderProps {
  productImage?: string | null;
  menus?: ProductMenu[] | null;
  onClick?: () => void;
}

export default function MenuImageSlider({
  productImage,
  menus,
  onClick,
}: MenuImageSliderProps) {
  const [currentSlide, setCurrentSlide] = useState(0);
  const settings = {
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    afterChange: (current: number) => setCurrentSlide(current), // 슬라이드 변경 후 상태 업데이트
  };

  if (productImage) {
    return (
      <div className="w-full h-full" onClick={onClick}>
        <ResponsiveCDNImage
          className="w-full h-full object-cover"
          src={productImage}
          alt="Menu"
          sizeRatio={1 / 2}
        />
      </div>
    );
  }

  if (!menus) {
    return <></>;
  }
  // 메뉴가 1개일 경우 슬라이더 대신 단일 이미지로 표시
  if (menus.length > 0 && menus.length <= 1) {
    const img = menus[0].img;
    const quantity = menus[0].quantity;
    return (
      <div className="w-full h-full" onClick={onClick}>
        <ResponsiveCDNImage
          className="w-full h-full object-cover"
          src={img}
          alt="Menu"
          sizeRatio={1 / 2}
        />

        <div className="absolute bottom-2 right-1.5 rounded-md bg-black opacity-80 text-white p-1 px-2">
          <p className="text-md font-semibold">x{quantity}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full h-full relative" onClick={onClick}>
      <Slider className="w-full h-full relative" {...settings}>
        {[...menus].reverse()?.map((menu: ProductMenu, index: number) => (
          <div key={menu.id} className="relative h-full">
            <div className="flex w-full h-full justify-center">
              <ResponsiveCDNImage
                className="w-full h-full object-cover"
                src={menu.img}
                alt={`Menu ${index + 1}`}
                sizeRatio={1 / 2}
              />
            </div>
            <div className="absolute bottom-2 right-1.5 rounded-md bg-black text-white p-1 px-2">
              <p className="text-md font-semibold">x{menu.quantity}</p>
            </div>
          </div>
        ))}
      </Slider>

      {/* Custom Dots */}
      <div className="absolute bottom-2 left-1/2 transform -translate-x-1/2 flex space-x-2">
        {menus.map((_: ProductMenu, index: number) => (
          <div
            key={index}
            className={`w-1.5 h-1.5 rounded-full cursor-pointer ${
              currentSlide === index ? "bg-[#1562fc]" : "bg-gray-300"
            }`}
            onClick={() => setCurrentSlide(index)}
          />
        ))}
      </div>
    </div>
  );
}
